import * as React from "react";
import { filter } from "graphql-anywhere";
import { makeStyles } from "@mui/styles";
import { fragments as sidebarListItemFragments } from "../Sidebar/SidebarListItem/graph";
import { useEffect, useState } from "react";
import { useRouter } from "found";
import PendingStatusView from "../PendingStatusView";
import Sidebar from "../Sidebar";
import SidebarListItem from "../Sidebar/SidebarListItem";
import Typography from "@mui/material/Typography";
import withBarcodePivot from "../BarcodePivot/withBarcodePivot";

const useStyles = makeStyles(theme => ({
  content: {
    height: "calc(100vh - 48px)",
    padding: theme.spacing(10)
  },

  spinnerWrapper: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    textAlign: "center"
  }
}));

const ProductionAppWithSidebar = ({
  acknowledgeOrderProductionJob,
  acknowledgeStockContainer,
  children,
  data,
  destinationRoute,
  errorMessage,
  fetchMore,
  lastOrderProductionJobScanned,
  lastStockContainerScanned,
  loading,
  ordersConnection
}) => {
  const classes = useStyles();
  const { router } = useRouter();

  // States:
  const [hasNextPage, setHasNextPage] = useState(true);
  const [isLoadingMore, setIsLoadingMore] = useState(false);

  useEffect(() => {
    if (lastStockContainerScanned) {
      router.push(
        `${destinationRoute}/${lastStockContainerScanned.orderProductionJob.order.id}?orderProductionJobId=${lastStockContainerScanned.orderProductionJob.id}`
      );
      acknowledgeStockContainer();
    }
  }, [
    acknowledgeStockContainer,
    destinationRoute,
    lastStockContainerScanned,
    router
  ]);

  useEffect(() => {
    if (lastOrderProductionJobScanned) {
      router.push(
        `${destinationRoute}/${lastOrderProductionJobScanned.order.id}?orderProductionJobId=${lastOrderProductionJobScanned.id}`
      );
      acknowledgeOrderProductionJob();
    }
  }, [
    acknowledgeOrderProductionJob,
    destinationRoute,
    lastOrderProductionJobScanned,
    router
  ]);

  useEffect(() => {
    if (data && !loading && !data.error) {
      // TODO: Should be just error if using useQuery hook
      if (data.ordersConnection?.edges.length === 1) {
        router.push(
          `${destinationRoute}/${data.ordersConnection.edges[0].node.id}`
        );
      }
    }
  }, [destinationRoute, data, router, loading]);

  // Handlers:
  const handleSideBarItemSelected = selectedIndex => {
    const orders = ordersConnection?.edges || [];
    const selectedOrder = orders[selectedIndex].node;
    router.push(`${destinationRoute}/${selectedOrder.id}`);
  };

  const handleSideBarScrolledToBottom = () => {
    if (isLoadingMore || !hasNextPage) {
      return;
    }

    setIsLoadingMore(true);
    fetchMore({
      updateQuery: (previousResult, { fetchMoreResult }) => {
        const newEdges = fetchMoreResult.ordersConnection.edges;
        const pageInfo = fetchMoreResult.ordersConnection.pageInfo;
        setHasNextPage(pageInfo.hasNextPage);
        return newEdges.length
          ? {
              ordersConnection: {
                pageInfo,
                __typename: previousResult.ordersConnection.__typename,
                edges: [...previousResult.ordersConnection.edges, ...newEdges]
              }
            }
          : previousResult;
      },
      variables: {
        after: ordersConnection.pageInfo.endCursor
      }
    }).finally(() => setIsLoadingMore(false));
  };

  return (
    <div>
      {children}
      {loading ? (
        <div>
          <PendingStatusView status="Loading" />
        </div>
      ) : errorMessage ? (
        <Typography align="center" variant="body2" color="error">
          {errorMessage}
        </Typography>
      ) : (
        <div>
          {ordersConnection && (
            <Sidebar
              isLoadingMoreItems={hasNextPage && isLoadingMore}
              isOpen={true}
              onItemSelected={handleSideBarItemSelected}
              onScrolledToBottom={handleSideBarScrolledToBottom}
            >
              {ordersConnection.edges.map(edge => (
                <SidebarListItem
                  key={edge.node.id}
                  order={filter(sidebarListItemFragments.order, edge.node)}
                />
              ))}
            </Sidebar>
          )}
          {!ordersConnection && (
            <div className={classes.content}>
              <Typography align="center" variant="h6" color="inherit">
                Scan or search for order
              </Typography>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default withBarcodePivot(ProductionAppWithSidebar);
